import React from "react";
import {
    ColoredText,
    WebsiteName,
    NavText,
    StyledNav,
    NavMenu,
} from "./Navbar.styles";
import { SHORT_NAME, SHORT_NAME_TEAM, TEAM_NAME } from "../../utils/info";
import Logo from "../../components/logos/Logo/Logo";
import { MAIN_COLOR } from "../../components/globalThemes";
import ErnestBiesLogo from "../../components/logos/partners/ErnestBiesLogo/ErnestBiesLogo";
import HamburgerMenu from "../../components/buttons/HamburgerMenu/HamburgerMenu";
import NavLink from "./NavLink/NavLink";
import { logoutAccount } from "../../actions/loginActions";
import { connect } from "react-redux";
import { logoutUser } from "../../helpers/fetchData";

const Navbar = ({ loggedIn, logoutAccount }) => {
    const logout = () => {
        logoutUser().then(() => logoutAccount());
    };

    return (
        <StyledNav>
            <WebsiteName title={TEAM_NAME} href={"/"}>
                <Logo style={{ marginLeft: 10 }} width={60} height={60} />
                <NavText>
                    <ColoredText color={MAIN_COLOR}>{SHORT_NAME}</ColoredText>
                    {` ${SHORT_NAME_TEAM}`}
                </NavText>
            </WebsiteName>
            <NavMenu id={"nav-menu"}>
                <NavLink title={"start"} pathname={"/"} />
                <NavLink title={"aktualności"} pathname={"/news"} />
                <NavLink title={"kadra"} pathname={"/team"} />
                <NavLink title={"rywalizacja"} pathname={"/competition"} />
                {loggedIn ? (
                    <>
                        <NavLink
                            title={"administracja"}
                            pathname={"/admin-access/panel"}
                        />
                        <NavLink
                            title={"wyloguj"}
                            color={"orange"}
                            navBorder
                            onClick={() => logout()}
                            pathname={"/"}
                        />
                    </>
                ) : (
                    <>
                        <NavLink title={"partnerzy"} pathname={"/#partners"} />
                        <NavLink title={"kontakt"} pathname={"/#contact"} />
                    </>
                )}
            </NavMenu>
            <ErnestBiesLogo position={"absolute"} scale={0.85} mobile />
            <HamburgerMenu />
        </StyledNav>
    );
};

const mapStateToProps = ({ loginReducer }) => loginReducer;
const mapDispatchToProps = { logoutAccount };

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
